module.exports = __webpack_public_path__ + "img/email-icon.a48dfe42.svg";